/** Every /otkryt-* page; the shell links them to each other. */
export const OPEN_FORMAT_LINKS = [
  { label: 'PNG', href: '/otkryt-png' },
  { label: 'SVG', href: '/otkryt-svg' },
  { label: 'HEIC', href: '/otkryt-heic' },
  { label: 'JPG', href: '/otkryt-jpg' },
  { label: 'WebP', href: '/otkryt-webp' },
  { label: 'AVIF', href: '/otkryt-avif' },
  { label: 'TIFF', href: '/otkryt-tiff' },
  { label: 'GIF', href: '/otkryt-gif' },
  { label: 'BMP', href: '/otkryt-bmp' },
  { label: 'ICO', href: '/otkryt-ico' },
] as const

export const NEXT_STEP_HREFS = {
  compress: '/szhat-izobrazhenie',
  crop: '/obrezat-foto',
  resize: '/izmenit-razmer-foto',
} as const
